import React from 'react'
import Navbar from "../Include/Navbar";
import Footer from "../Include/Footer";
function GrievanceRedressal() {
  return (
    <>
    <Navbar/>
    <div className="about-page">
      <div className="container">
        <h1>Grievance Redressal</h1>
        <p>
          At Innosutra AI Private Limited, we are committed to delivering a
          smooth, reliable, and user-friendly experience across our services. We
          take user concerns seriously and have established a structured
          grievance redressal mechanism to ensure timely and effective
          resolution of complaints.
        </p>
        <section className="section">
          <h2>1. Grievance Officer Details</h2>
          <p>
            For any concerns, complaints, or legal queries, users may contact
            our designated Grievance Officer:
          </p>
          <p>
            <strong>Name:</strong> Haresh Rathore
          </p>
          <p>
            <strong>Email:</strong>{' '}
            innosutraaiprivatelimited@gmail.com
          </p>
          <p>
            <strong>Phone:</strong> 9727555057
          </p>
          <p>
            <strong>Address:</strong> E-213, 21st Floor, ANA Avant Garde, WEH,
            Shivaji Chowk, Mira Road, Thane – 401107, Maharashtra, India
          </p>
        </section>
        <section className="section">
          <h2>2. How to Raise a Complaint</h2>
          <p>
            Users can submit their complaints or queries through:
          </p>
          <ul>
            <li>Email communication</li>
            <li>Phone contact</li>
          </ul>
          <p>
            Please include relevant details such as your name, contact
            information, and a clear description of the issue to help us
            resolve it efficiently.
          </p>
        </section>
        <section className="section">
          <h2>3. Acknowledgement of Complaint</h2>
          <p>
            All complaints will be acknowledged within 24 hours of receipt.
          </p>
        </section>
        <section className="section">
          <h2>4. Resolution Timeline</h2>
          <p>
            We aim to resolve all valid complaints within 15 days from the date
            of receipt.
          </p>
          <p>
            In case additional time is required due to the complexity of the
            issue, the user will be informed accordingly.
          </p>
        </section>
        <section className="section">
          <h2>5. Commitment to Users</h2>
          <p>Our goal is to ensure:</p>
          <ul>
            <li>Transparent communication</li>
            <li>Fair and unbiased resolution</li>
            <li>
              Continuous improvement of our services based on user feedback
            </li>
          </ul>
          <p>
            We value your trust and are dedicated to providing a responsive and
            responsible support system.
          </p>
        </section>
      </div>
    </div>
    <Footer/>
    </>
  )
}
export default GrievanceRedressal